import { clsx } from 'clsx/lite'
import React, { useEffect, useState } from 'react'

export type RadioProps = {
  disabled?: boolean
  inputProps?: Record<string, unknown>
  label?: string | React.ReactNode
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  required?: boolean
  selected?: boolean
  value?: any
} & React.HTMLAttributes<HTMLElement>

export const Radio: React.FC<RadioProps> = ({
  disabled = false,
  inputProps,
  label,
  onChange,
  required = false,
  selected = false,
  value = 'on',
  className,
  ...props
}) => {
  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    setIsChecked(selected)
  }, [selected])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(!isChecked)
    if (onChange) {
      onChange(event)
    }
  }

  return (
    <label
      className={clsx(
        'flex h-10 select-none rounded-[5px] border-solid bg-background-default px-[5px] py-[10px]',
        'focus-within:outline focus-within:outline-3 focus-within:outline-offset-4 focus-within:outline-border-focus',
        disabled
          ? 'pointer-events-none cursor-default opacity-50'
          : 'pointer-events-auto cursor-pointer hover:ring-2 hover:ring-grey-600 hover:ring-offset-0',
        isChecked
          ? 'border-2 border-theme-selected-main'
          : 'border border-border-default',
        className
      )}
      {...props}
    >
      <div className="flex flex-1 items-center justify-center">
        <input
          checked={isChecked}
          className="absolute -left-[9999px] opacity-0"
          disabled={disabled}
          required={required}
          type="radio"
          value={value}
          onChange={handleChange}
          {...inputProps}
        />
        {label && <div className={clsx('', 'font-medium')}>{label}</div>}
      </div>
    </label>
  )
}
